module.exports = __webpack_public_path__ + "static/media/print.837710ad.svg";